<template>
    <div class="house-feature-mb" :class="{'contract-mode': $route.query.mode == 'contract'}">
        <div v-if="goodLive || featureList.length" class="tags">
            <div class="wrap">
                <div v-if="goodLive" class="good-to-live">
                    <img src="@/assets/img/shareHouse/good_to_live.svg" alt="">
                    好住認證
                </div>
                <div class="feature" v-for="(item, index) in featureList" :key="index">
                    {{item.itemName}}
                </div>
            </div>
        </div>
        <h1 class="title">{{houseName}}</h1>
        <div class="amount-wrap h-align">
            <div class="amount">
                <div class="price">
                    {{toCurrency(rentMonthly)}}
                </div>
                <div class="unit">
                    元/月
                </div>
                <div v-if="houseDetail.complete" class="preview-contract" @click="toPreviewContract()">
                    <div>
                        預覽合約
                    </div>
                    <img src="@/assets/img/shareHouse/arrow_right_blue_light.svg" alt="">
                </div>
            </div>
            <div v-if="attorney" class="landlord-auth h-align" @click="$store.dispatch('setModalStatus', {state: true, type: 'landlordAuthModal'})">
                <!-- 房東委託證明 -->
                <img src="@/assets/img/shareHouse/landlord_auth.svg" alt="">
            </div>
        </div>
        <div v-if="getHouseSetting(rentInclude) != ''" class="rent-include">
                租金含{{getHouseSetting(rentInclude)}}
        </div>
        <div class="landlord-info">
            <div class="shot-wrap" >
                <div class="ring-bg" :class="{'user': !taskTaker && landlordInfo.audited, 'enterprise': !taskTaker && isEnterprise, 'tasker': taskTaker}"></div>
                <div class="shot">
                    <img v-if="landlordInfo.landlordImage" class="shot-img" :src="imageUrl(landlordInfo.landlordImage)" alt="">
                    <img v-else class="shot-img" src="@/assets/img/shareHouse/shot.svg" alt="">
                    <!-- <img class="award" src="@/assets/img/shareHouse/award.svg" alt=""> -->
                </div>
            </div>
            <div class="group">
                <div v-if="enterpiseName" class="enterprise-name">
                    {{enterpiseName}}
                </div>
                <div v-if="taskTaker" class="name-and-phone">
                    <div class="name">
                        {{taskTakerInfo.landlordName}}
                    </div>
                    <div class="phone">
                        {{taskTakerInfo.phoneNumber}}
                        
                        <a v-if="ispreviewHousePage"><img src="@/assets/img/shareHouse/phone.svg" alt=""></a>
                        <a v-else click="$analytics.logEvent('連絡房東', { screen_name: '連絡房東'})" :href="'tel:'+taskTakerInfo.phoneNumber+''"><img src="@/assets/img/shareHouse/phone.svg" alt=""></a>
                    </div>
                </div>
                <div v-else class="name-and-phone">
                    <div class="name">
                        {{landlordInfo.landlordName}}
                    </div>
                    <div class="phone">
                        {{landlordInfo.phoneNumber}}
                        
                        <a v-if="ispreviewHousePage"><img src="@/assets/img/shareHouse/phone.svg" alt=""></a>
                        <a v-else click="$analytics.logEvent('連絡房東', { screen_name: '連絡房東'})" :href="'tel:'+landlordInfo.phoneNumber+''"><img src="@/assets/img/shareHouse/phone.svg" alt=""></a>
                    </div>
                </div>
                <div v-if="!taskTaker && landlordInfo.audited && !isEnterprise" class="certification">
                    認證房東身份
                </div>
                <div v-if="!taskTaker && !landlordInfo.audited" class="not-certification">
                    未認證房東身份
                </div>
                <div v-if="taskTaker" class="task-taker">
                    認證代理人身份
                </div>
            </div>
        </div>
        <div v-if="goodHouse" class="good-house">
            <span class="certification good">
                <img src="@/assets/img/shareHouse/good_house_mb.svg" alt="">
                <span>飛豬好房</span>
            </span>
            <span class="certification">
                <img src="@/assets/img/shareHouse/tick_red.svg" alt="">
                飛豬親自認證
            </span>
            <span class="certification">
                <img src="@/assets/img/shareHouse/tick_red.svg" alt="">
                租房品質保證
            </span>
        </div>
        <div class="house-info">
            <div class="list">
                <span class="title">出租類型</span>
                <span class="content">{{houseType?`${houseType}`:'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">坪數</span>
                <span class="content">{{size?`${size}坪`:'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">房屋類型</span>
                <span class="content">{{buildingType?`${buildingType}`:'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">房屋格局</span>
                <span class="content">{{housePattern?`${housePattern}`:'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">位於樓層</span>
                <span class="content">{{floor?`${floor}樓`:'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">最快起租日</span>
                <span class="content">{{moveInDate?getFormatDate(moveInDate):'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">最短租期</span>
                <span class="content">{{shortestPeriod?`${shortestPeriod}個月`:'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">繳租時間</span>
                <span class="content">{{payRentDay?`${payRentDay}`:'尚未提供'}}</span>
            </div>
            <div class="list">
                <span class="title">房源編號</span>
                <span class="content">{{houseCid}}</span>
            </div>
            
        </div>
        <div v-if="nearStation" class="near-station">
            {{nearStation}}
        </div>
        <div class="postingTime" v-if="postingTime">
            <img style="margin-right: 6px;" src="@/assets/img/icon/icon14X14Clock.svg" alt="">
            <span class="content">此房源於 {{ postingTime }} 發佈</span>
        </div>
        <div class="address">
            <img src="@/assets/img/shareHouse/marker_blue.svg" alt="">
            {{address}} 
        </div>
        <button v-if="houseStatus == 2" class="booking is-booking">此房源已被預定</button>
        <a v-else-if="ispreviewHousePage" rel="noopener noreferrer">
            <button class="booking">預定房源</button>
        </a>
        <a v-else @click="openHouse" target="_blank" rel="noopener noreferrer">
            <button class="booking">預定房源</button>
        </a>
        <span v-if="houseStatus == 2" class="is-booking-alarm">
            <img src="@/assets/img/shareHouse/alarm_red.svg" alt="">
            立即下載飛豬找房app，追蹤房源。
        </span>
        <div v-if="isFixed && $route.query.mode != 'contract'" class="fixed-booking">
            <div class="amount">
                <div class="price">
                    {{toCurrency(rentMonthly)}}
                </div>
                <div class="unit">
                    元/月
                </div>
            </div>
            <div class="btn-group">
                <a v-if="ispreviewHousePage"><button class="call">聯絡房東</button></a>
                <a v-else @click="$analytics.logEvent('連絡房東', { screen_name: '連絡房東'})" :href="'tel:'+landlordInfo.phoneNumber+''"><button class="call">聯絡房東</button></a>

                <button v-if="houseStatus == 2" class="booking is-booking">已被預定</button>
                <a v-else-if="ispreviewHousePage" rel="noopener noreferrer">
                    <button class="booking">預定房源</button>
                </a>
                <a v-else @click="openHouse" target="_blank" rel="noopener noreferrer">
                    <button class="booking">預定房源</button>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { 
    baseDomain,
} from "@/apis/api.js"; 
import constant from '@/constant'

export default {
    data () {
        return{
            isFixed: false,
            ispreviewHousePage: false,
        }
    },
    watch: {
        $route:{
            handler: function (val) {
                if(val.name == 'previewHouse'){
                    this.ispreviewHousePage = true
                }else{
                    this.ispreviewHousePage = false
                }
            },
            immediate: true,
            deep: true
        },
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            let houseFeature = document.getElementsByClassName('house-feature-mb')[0]
            let toTopDistance = houseFeature.offsetHeight + houseFeature.offsetTop
            if(scrollTop > toTopDistance){
                this.isFixed = true
            }else{
                this.isFixed = false
            }
        },
        imageUrl: function (url) {
            return baseDomain+url
        },
        getHouseSetting: function (arr) {
            let text = ''
            arr.map( (item, index) => {
                if(item.check == true){
                    text += item.itemName+ '/'
                }
            })
            return text.substring(0,text.length-1)
        },
        toPreviewContract: function () {
            let routerUrl = this.$router.resolve({ name: 'shareHousePreviewContract', query: {houseCid: this.houseCid}})
            window.open(routerUrl.href, '_blank');
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        openHouse: function () {
            let _self =this
            _self.$analytics.logEvent('預定房源', { screen_name: '預定房源'})
            if(this.system == 'pc'){
                this.$store.dispatch('setModalStatus', {state: true, type: 'downloadApp'})
            }else{
                // console.log(constant.fetuzbookTenantSchema+'://?houseCid='+this.houseCid)
                document.location = constant.fetuzbookTenantSchema+'://?houseCid='+this.houseCid;
                var time = (new Date()).getTime();
                setTimeout(function(){
                    setTimeout(function(){ // <-- start new thread after activation
                        var now = (new Date()).getTime();
                        if((now - time)<400) {
                            // if(confirm('你未安裝飛豬找房，將引導AppStore')){
                                window.open(_self.appUrl.tenant)
                            // }
                        }
                    }, 10); // <-- start new thread after activation
                }, 300);
            }
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'/'+formatDate[5]+'/'+formatDate[6];
        },
    },
    computed: {
        ...mapGetters({
            houseName: 'GET_SHARE_HOUSE_NAME',
            rentMonthly: 'GET_SHARE_HOUSE_RENT_MONTHLY',
            houseType: 'GET_SHARE_HOUSE_HOUSETYPE',
            buildingType: 'GET_SHARE_HOUSE_BUILDINGTYPE',
            houseCid: 'GET_SHARE_HOUSE_ID',
            size: 'GET_SHARE_HOUSE_SIZE',
            landlordInfo: 'GET_SHARE_HOUSE_LANDLORD_INFO',
            taskTakerInfo: 'GET_SHARE_HOUSE_TASK_TAKER_INFO',
            shortestPeriod: 'GET_SHARE_HOUSE_SHOTEST_PERIOD',
            floor: 'GET_SHARE_HOUSE_FLOOR',
            moveInDate: 'GET_SHARE_HOUSE_MOVE_IN_DATE',
            housePattern: 'GET_SHARE_HOUSE_PATTERN',
            address: 'GET_SHARE_HOUSE_ADDRESS',
            rentInclude: 'GET_SHARE_HOUSE_RENT_INCLUDE',
            enterpiseName: 'GET_SHARE_HOUSE_ENTERPRISE_NAME',
            isEnterprise: 'GET_SHARE_HOUSE_ENTERPRISE',
            taskTaker: 'GET_SHARE_HOUSE_TASK_TAKER',
            system: 'GET_DEVICE_SYSTEM',
            appUrl: 'GET_APP_URL',
            houseStatus: 'GET_SHARE_HOUSE_STATUS',
            payRentDay: 'GET_SHARE_HOUSE_PAY_RENT_DAY',
            goodHouse: 'GET_SHARE_HOUSE_GOOD_HOUSE',
            houseCid: 'GET_SHARE_HOUSE_ID',
            goodLive: 'GET_SHARE_HOUSE_GOOD_LIVE',
            featureList: 'GET_SHARE_HOUSE_FEATURE_LIST',
            nearStation: 'GET_SHARE_NEAR_STATION',
            attorney: 'GET_SHARE_HOUSE_HAS_ATTORNEY',
            houseDetail: 'GET_SHARE_HOUSE_DETAIL',
            postingTime: 'GET_SHARE_HOUSE_POSTING_TIME'
        })
    },
}
</script>
<style lang="scss" scoped>
    .house-feature-mb{
        display: none;
        position: relative;
        width: 100%;
        background-color: #ffffff;
        margin-bottom: 18px;
        &.contract-mode{
            display: block;
        }
        .tags{
            font-size: 15px;
            overflow-y: hidden;
            >.wrap{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                width: 700px;
                >div{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 5px;
                    margin-right: 8px;
                    height: 28px;
                    padding: 0 8px;
                    margin-bottom: 8px;
                }
                .good-to-live{
                    background-color: #d7effe;
                    color: #01bdfe;
                    >img{
                        margin-right: 5px;
                    }
                }
                .feature{
                    background-color: rgba($color: #9a9999, $alpha: 0.1);
                    color: #9a9999;
                }
            }
        }
        h1.title{
            font-size: 22px;
            font-weight: 500;
            line-height: 1.47;
            margin-bottom: 20px;
            color: #3a455f;
        }
        .amount-wrap{
            justify-content: space-between;
            .amount{
                display: flex;
                font-weight: 500;
                color: #fb6b63;
                align-items: flex-end;
                margin-bottom: 12px;
                .price{
                    font-size: 22px;
                    margin-right: 8px;
                }
                .unit{
                    font-size: 14px;
                }
                .preview-contract{
                    display: flex;
                    align-items: center;
                    color: #01bdfe;
                    cursor: pointer;
                    margin-left: 16px;
                    >img{
                        position: relative;
                        margin-left: 5px;
                        top: 2px;
                    }
                }
            }
            .landlord-auth{
                font-size: 15.4px;
                cursor: pointer;
                >img{
                    width: 104px;
                }
            }
        }
        .rent-include{
            font-size: 13px;
            color: #909090;
            margin-bottom: 19px;
        }
        .good-house{
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #f6f8f9;
            border-radius: 6px;
            margin-bottom: 14px;
            height: 46px;
            padding: 0 18px;
            box-sizing: border-box;
            >img{
                width: 100%;
            }
            .certification{
                position: relative;
                display: flex;
                align-items: center;
                color: #666666;
                width: 104px;
                >img{
                    margin-right: 7px;
                }
                &.good{
                    >img{
                        position: absolute;
                        width: 115%;
                        left: -15px;
                    }
                    >span{
                        position: absolute;
                        color: #303030;
                        right: 20px;
                    }
                }
            }
        }
        .landlord-info{
            display: flex;
            align-items: center;
            margin-bottom: 21px;
            .shot-wrap.good{
                background: url(data:image/png;base64,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);
                background-repeat: no-repeat;
                .shot{
                    .shot-img{
                        width: 100%;
                        background: #fff;
                        position: absolute;
                    }
                }
            }
            .shot-wrap{
                position: relative;
                width: 60px;
                height: 60px;
                margin-right: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                .shot{
                    display: flex;
                    align-items: center;
                    .shot-img{
                        width: 100%;
                        background: #fff;
                        position: absolute;
                    }
                }
                .ring-bg{
                    width: 100%;
                    height: 100%;
                    background-repeat: no-repeat;
                    background-size: cover;
                    z-index: 5;
                    &.user{
                        background: url('../../assets/img/shareHouse/shot/user.svg');
                    }
                    &.enterprise{
                        background: url('../../assets/img/shareHouse/shot/enterprise.svg');
                    }
                    &.tasker{
                        background: url('../../assets/img/shareHouse/shot/tasker.svg');
                    }
                }
                .shot{
                    position: absolute;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    .shot-img{
                        width: 100%;
                    }
                    .award{
                        position: absolute;
                        position: absolute;
                        bottom: -11px;
                        right: -5px;
                    }
                    
                }
            }
            .group{
                .enterprise-name{
                    font-size: 14px;
                    font-weight: 400;
                    color: #848383;
                    margin-bottom: 6px;
                }
                .name-and-phone{
                    display: flex;
                    align-items: center;
                    .name{
                        font-size: 18px;
                        margin-right: 16px;
                    }
                    .phone{
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        font-weight: 500;
                        img{
                            margin-left: 8px;
                            cursor: pointer;
                        }
                    }
                }
                .certification{
                    display: flex;
                    align-items: center;
                    color: #3fccfc;
                    margin-top: 8px;
                    img{
                        margin-right: 4px;
                    }
                }
                .not-certification{
                    display: flex;
                    align-items: center;
                    color: #8f8f8f;
                    margin-top: 8px;
                }
                .task-taker{
                    color: #ff9275;
                    margin-top: 8px;
                    font-weight: 400;
                }
            }
        }
        .near-station{
            position: relative;
            color: #ff9275;
            font-size: 16px;
            font-weight: 400;
            margin-top: 10px;
            margin-left: 10px;
            margin-bottom: 16px;
            &::before{
                content: '';
                position: absolute;
                height: 14px;
                width: 2px;
                background: #ff9275;
                left: -10px;
                top: 3px;
            }
        }
        .postingTime {
            margin-bottom: 14px;
        }
        button.booking{
            width: 100%;
            height: 44px;
            border-radius: 8px;
            background-color: #fb6b63;
            font-size: 16px;
            color: #fff;
            cursor: pointer;
            margin-bottom: 12px;
        }
        button.booking.is-booking{
            margin-bottom: 8px;
            background-color: #cccccc;
        }
        .is-booking-alarm{
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #fb6b63;
            margin-bottom: 17px;
            img{
                margin-right: 4px;
            }
        }
        .house-info{
            margin-bottom: 16px;
            .list{
                display: flex;
                margin-bottom: 18px;
                font-size: 16px;
                .title{
                    width: 80px;
                    color: #909090;
                    margin-right: 38px;
                    display: inline-flex;
                }
                .content{
                    display: flex;
                }
            }
            .list:last-child{
                margin-bottom: 0px;
            }
        }
        .address{
            display: flex;
            align-items: center;
            font-size: 16px;
            margin-bottom: 23px;
            color: #2db2ff;
            img{
                margin-right: 6px;
            }
        }
    }
    .fixed-booking{
        position: fixed;
        width: 100%;
        height: 66px;
        left: 0;
        bottom: 0;
        box-shadow: 0 -1px 10px 0 rgba(191, 191, 191, 0.23);
        background-color: #ffffff;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .amount{
            position: relative;
            left: 20px;
            display: flex;
            font-weight: 500;
            color: #3a455f;
            align-items: flex-end;
            margin-bottom: 0px;
            .price{
                font-size: 20px;
                margin-right: 4px;
            }
            .unit{
                font-size: 12px;
            }
        }
        .btn-group{
            position: relative;
            right: 20px;
            button.call{
                width: 104px;
                margin-bottom: 0px;
                border-radius: 8px;
                border: solid 1px #909090;
                height: 44px;
                background: #fff;
                font-size: 16px;
                color: #909090;
                cursor: pointer;
                margin-right: 4px;
            }
            button.booking{
                width: 104px;
                margin-bottom: 0px;
            }
        }
    }
    @media (max-width: 992px) {
        .house-feature-mb{
            display: block;
        }
    }
    @media (max-width: 375px) {
        .house-feature-mb{
            .good-house{
                .certification{
                    font-size: 12px;
                    &.good{
                        >span{
                            right: 20px;
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 320px) {
        .house-feature-mb{
            .fixed-booking{
                .btn-group{
                    button.call{
                        width: 80px;
                    }
                    button.booking{
                        width: 80px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/houseFeatureMb.vue